import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon, LockIcon, ZapIcon, SmartphoneIcon, UndoIcon } from 'lucide-react';
const MP_LOGO = 'https://cdn.magicpatterns.com/uploads/etkTaXj7sZYHHx3bBZ48Fm/pasted-image.png';
const plans = {
  combo: {
    label: 'COMBO COMPLETO',
    badge: '⭐ MÁS ELEGIDO — MEJOR VALOR',
    oldPrice: '$79.990',
    price: '$29.990',
    saving: 'Ahorrás $50.000',
    checkoutUrl: 'https://checkout11.rosetadigital.com/cart/45396276412553:1',
    items: [{
      text: '6 Tomos PDF (El Lector de Mentes completo)',
      included: true,
      highlight: true
    }, {
      text: '+300 páginas de contenido práctico',
      included: true,
      highlight: true
    }, {
      text: 'BONUS 1: Escáner Express',
      included: true,
      bonus: true
    }, {
      text: 'BONUS 2: Microexpresiones en Vivo',
      included: true,
      bonus: true
    }, {
      text: 'BONUS 3: Semáforo del Deseo',
      included: true,
      bonus: true
    }, {
      text: 'BONUS 4: Interrogatorio Suave',
      included: true,
      bonus: true
    }, {
      text: 'BONUS 5: Anti Manipulación',
      included: true,
      bonus: true
    }, {
      text: 'BONUS 6: Presencia y Carisma',
      included: true,
      bonus: true
    }, {
      text: 'MANUAL EXTRA: El Protocolo de Sombra',
      subtitle: 'Técnicas avanzadas de lectura encubierta',
      included: true,
      special: true
    }, {
      text: 'Acceso inmediato por descarga',
      included: true
    }]
  },
  base: {
    label: 'PACK ESENCIAL',
    badge: null,
    oldPrice: '$49.990',
    price: '$19.990',
    saving: null,
    checkoutUrl: 'https://checkout11.rosetadigital.com/cart/45396271005833:1',
    items: [{
      text: '6 Tomos PDF (El Lector de Mentes completo)',
      included: true
    }, {
      text: '+300 páginas de contenido práctico',
      included: true
    }, {
      text: 'BONUS 1: Escáner Express',
      included: true,
      bonus: true
    }, {
      text: 'BONUS 2: Microexpresiones en Vivo',
      included: true,
      bonus: true
    }, {
      text: 'BONUS 3: Semáforo del Deseo',
      included: true,
      bonus: true
    }, {
      text: 'BONUS 4: Interrogatorio Suave',
      included: true,
      bonus: true
    }, {
      text: 'BONUS 5: Anti Manipulación',
      included: true,
      bonus: true
    }, {
      text: 'BONUS 6: Presencia y Carisma',
      included: true,
      bonus: true
    }, {
      text: 'Acceso inmediato por descarga',
      included: true
    }, {
      text: 'Compatible con celular, tablet y PC',
      included: true
    }, {
      text: 'Sin Protocolo de Sombra',
      included: false
    }]
  }
};
function MercadoPagoBadge() {
  return <div className="flex items-center justify-center gap-2 py-1.5 px-4 bg-white rounded-lg my-1.5" data-id="element-137">
      <img src={MP_LOGO} alt="Mercado Pago" className="h-5 md:h-7 object-contain" data-id="element-138" />
      <span className="text-xs text-gray-600 font-medium" data-id="element-139">
        Pago procesado por Mercado Pago
      </span>
    </div>;
}
export function PricingSelector() {
  const [selectedPlan, setSelectedPlan] = useState<'base' | 'combo'>('combo');
  const current = plans[selectedPlan];
  const isCombo = selectedPlan === 'combo';
  return <section id="checkout" className="py-4 px-4 bg-deep-black scroll-mt-20" data-id="element-140">
      <div className="max-w-2xl mx-auto" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-2" data-id="element-142">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-white mb-0.5" data-id="element-143">
            Elegí tu acceso
          </h2>
          <p className="text-sm text-smoke/80" data-id="element-144">
            Una sola vez. Tuyo para siempre.
          </p>
        </motion.div>

        {/* Mercado Pago badge BEFORE checkout */}
        <MercadoPagoBadge data-id="element-145" />

        {/* Plan Toggle */}
        <div className="flex gap-2 mb-3 justify-center" data-id="element-146">
          <button onClick={() => setSelectedPlan('combo')} className={`relative px-5 py-2 rounded-lg font-heading font-bold text-xs tracking-wide transition-all duration-300 border-2 ${isCombo ? 'border-gold bg-gold/10 text-gold shadow-glow-gold' : 'border-white/10 bg-deep-black text-smoke/60 hover:border-white/30'}`} data-id="element-147">
            {isCombo && <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-gold text-deep-black font-bold px-2 py-0.5 rounded-full text-[9px] whitespace-nowrap shadow-lg" data-id="element-148">
                ⭐ MÁS ELEGIDO
              </span>}
            COMBO COMPLETO
          </button>
          <button onClick={() => setSelectedPlan('base')} className={`px-5 py-2 rounded-lg font-heading font-bold text-xs tracking-wide transition-all duration-300 border-2 ${!isCombo ? 'border-electric-blue bg-electric-blue/10 text-electric-blue shadow-glow-blue' : 'border-white/10 bg-deep-black text-smoke/60 hover:border-white/30'}`} data-id="element-149">
            PACK ESENCIAL
          </button>
        </div>

        {/* Selected Plan Card */}
        <motion.div key={selectedPlan} initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.35
      }} className={`rounded-lg p-4 border-2 transition-all duration-300 ${isCombo ? 'border-gold bg-[#141410] shadow-glow-gold' : 'border-electric-blue bg-[#111] shadow-glow-blue'}`} data-id="element-150">
          <div className="flex items-center justify-between mb-2" data-id="element-151">
            <span className={`text-xs font-bold tracking-widest uppercase ${isCombo ? 'text-gold' : 'text-smoke/60'}`} data-id="element-152">
              {current.label}
            </span>
            {current.saving && <span className="bg-green-500/20 text-green-400 text-[10px] font-bold px-2 py-0.5 rounded-full border border-green-500/30" data-id="element-153">
                {current.saving}
              </span>}
          </div>

          <ul className="space-y-1 mb-2" data-id="element-154">
            {current.items.map((item, index) => <li key={index} className={`flex items-start gap-2 text-sm ${!item.included ? 'opacity-50' : ''}`} data-id="element-155">
                {item.included ? <CheckIcon className={`w-4 h-4 shrink-0 mt-0.5 ${(item as any).special ? 'text-electric-blue' : isCombo ? 'text-gold' : 'text-electric-blue'}`} data-id="element-156" /> : <XIcon className="w-4 h-4 text-red-500 shrink-0 mt-0.5" data-id="element-157" />}
                <span className="flex flex-col" data-id="element-158">
                  <span className="flex items-center gap-2 flex-wrap" data-id="element-159">
                    <span className={`${(item as any).highlight ? 'text-white font-medium' : (item as any).special ? 'text-electric-blue font-medium' : 'text-smoke/90'}`} data-id="element-160">
                      {item.text}
                    </span>
                    {(item as any).bonus && <span className="text-green-400 font-bold text-xs bg-green-500/15 px-1.5 py-0.5 rounded border border-green-500/30" data-id="element-161">
                        GRATIS
                      </span>}
                  </span>
                  {(item as any).subtitle && <span className="text-xs text-smoke/50 mt-0.5" data-id="element-162">
                      {(item as any).subtitle}
                    </span>}
                </span>
              </li>)}
          </ul>
        </motion.div>

        {/* Price + CTA */}
        <div className="text-center mt-2" data-id="element-163">
          <div className="mb-1.5" data-id="element-164">
            <div className="flex items-baseline justify-center gap-2" data-id="element-165">
              <span className="text-smoke/40 line-through text-sm" data-id="element-166">
                {current.oldPrice}
              </span>
              <span className="text-2xl md:text-3xl font-heading font-bold text-white" data-id="element-167">
                {current.price}
              </span>
              <span className="text-xs font-normal text-smoke/60" data-id="element-168">ARS</span>
            </div>
          </div>

          <a href={current.checkoutUrl} className="inline-flex items-center justify-center gap-2 w-full md:w-auto bg-green-600 hover:bg-green-500 text-white font-heading font-bold text-base px-8 py-3 rounded-lg shadow-[0_0_30px_rgba(201,168,76,0.3)] transition-all transform hover:scale-105 mb-3" data-id="element-169">
            <LockIcon className="w-5 h-5" data-id="element-170" />
            🔐 COMPRAR AHORA — ACCESO INMEDIATO
          </a>

          <div className="flex flex-wrap justify-center items-center gap-2 md:gap-4 text-[10px] text-smoke/60 mb-2" data-id="element-171">
            <span className="flex items-center gap-1" data-id="element-172">
              <LockIcon className="w-3 h-3" data-id="element-173" /> Pago Seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-174">
              <ZapIcon className="w-3 h-3" data-id="element-175" /> Acceso Inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-176">
              <SmartphoneIcon className="w-3 h-3" data-id="element-177" /> Todos los dispositivos
            </span>
            <span className="flex items-center gap-1" data-id="element-178">
              <UndoIcon className="w-3 h-3" data-id="element-179" /> Garantía 7 días
            </span>
          </div>

          {/* Mercado Pago badge AFTER checkout */}
          <MercadoPagoBadge data-id="element-180" />
        </div>
      </div>
    </section>;
}